import React from "react";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  Button,
  Stack,
  useTheme,
//   Collapse,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import ExpandLessIcon from "@mui/icons-material/ExpandLess";
// import DescriptionIcon from "@mui/icons-material/Description";
// import LockIcon from "@mui/icons-material/Lock";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import UserIcon from "@mui/icons-material/Person";

type OnboardingModalProps = {
  open: boolean;
  onClose: () => void;
  onWhatsAppClick: () => void;
};

const OnboardingModal: React.FC<OnboardingModalProps> = ({
  open,
  onClose,
  onWhatsAppClick,
}) => {
  const theme = useTheme();
//   const [showSteps, setShowSteps] = useState(false);

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="onboarding-modal-title"
    >
      <Box
        sx={{
          position: "absolute" as const,
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: theme.palette.background.paper,
          color: theme.palette.text.primary,
          boxShadow: 24,
          p: 4,
          borderRadius: 3,
          width: "90%",
          maxWidth: 600,
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>

        <Typography variant="h4" align="center" fontWeight={600} gutterBottom>
          Let’s Begin — Together
        </Typography>

        <Typography variant="h6" align="center" mb={4}>
          We know how challenging this can be. That’s why we start with a short
          confirmation call — to understand your situation and explain how we
          can help, clearly and calmly.
        </Typography>

        <Divider sx={{ mb: 3 }} />

        <Stack spacing={1} mb={3}>
          <Typography variant="h5" fontWeight={600} align="center">
            Book Your Confirmation Call
          </Typography>
          <Typography variant="body1" align="center">
            One of our experts will call you personally. We’ll ask a few simple
            questions, make sure you feel confident, and walk you through the
            next steps — no obligations, no pressure.
          </Typography>
        </Stack>

        <Stack direction="row" justifyContent="center" mb={3}>
          <Button
            variant="contained"
            color="success"
            startIcon={<WhatsAppIcon />}
            onClick={onWhatsAppClick}
            sx={{ minWidth: 220, fontWeight: 600 }}
          >
            Chat with WhatsApp
          </Button>
        </Stack>

        <Typography variant="h6" align="center" gutterBottom>
          💬 What Happens Next?
        </Typography>

        <Stack spacing={1} alignItems="center" mb={3}>
          <Typography variant="body1" align="center">
            • You’ll get a clear, personalized recovery plan
          </Typography>
          <Typography variant="body1" align="center">
            • We’ll explain exactly what we might need from you
          </Typography>
          <Typography variant="body1" align="center">
            • You decide how and when to move forward — we’re here to support you
          </Typography>
        </Stack>

        <Typography variant="body2" align="center" mb={3}>
          📞 Prefer to talk by phone? Call us directly:{" "}
          <strong>+1 902-901-5915</strong> or leave a message — we’ll get back to
          you as soon as possible.
        </Typography>

        {/* <Button
          onClick={() => setShowSteps((prev) => !prev)}
          variant="text"
          sx={{ mx: "auto", display: "block", fontWeight: 600 }}
          endIcon={showSteps ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        >
          Learn More
        </Button>

        <Collapse in={showSteps}>
          <Divider sx={{ my: 3 }} />

          <Stack spacing={3}>
            <Box>
              <Typography variant="h6" fontWeight={600} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <UserIcon variant="h6" fontWeight={600} />
                Step 2: Speak with Your Case Specialist
              </Typography>
              <Typography variant="body2">
                You’ll be matched with a dedicated Cyber Intelligence Expert, who
                will carefully review your case, answer your questions, and guide
                you every step of the way.
              </Typography>
            </Box>

            <Box>
              <Typography
                variant="h6"
                fontWeight={600}
                // color="primary"
                sx={{ display: "flex", alignItems: "center", gap: 1 }}
              >
                <DescriptionIcon variant="h6" fontWeight={600} />
                Step 3: Upload Your Documents
              </Typography>
              <Typography variant="body2">
                Help us investigate your case efficiently by uploading any relevant
                files—screenshots, emails, or transaction receipts. The more
                details, the faster we can act.
              </Typography>
            </Box>

            <Box>
              <Typography
                variant="h6"
                fontWeight={600}
                // color="primary"
                sx={{ display: "flex", alignItems: "center", gap: 1 }}
              >
                <LockIcon variant="h6" fontWeight={600}/>
                Step 4: Secure Payment
              </Typography>
              <Typography variant="body2">
                Once your case is reviewed and ready, you can proceed with secure
                payment via trusted international gateways. All payment
                information is encrypted for your safety.
              </Typography>
            </Box>

            <Box>
              <Typography
                variant="h6"
                fontWeight={600}
                color="success.main"
                sx={{ display: "flex", alignItems: "center", gap: 1 }}
              >
                <CheckCircleIcon fontSize="small" />
                You’re Ready to Begin!
              </Typography>
              <Typography variant="body2">
                As soon as these steps are complete, our team will immediately
                start working on your case. You’ll receive live updates and have
                full access to your dashboard at all times.
              </Typography>
            </Box>
          </Stack>
        </Collapse> */}

        <Divider sx={{ my: 4 }} />

        <Stack direction="row" justifyContent="center" mt={2}>
          <Button
            onClick={onClose}
            variant="contained"
            color="primary"
            sx={{ minWidth: 220, fontWeight: 600 }}
          >
            Got it
          </Button>
        </Stack>

        <Typography
          variant="caption"
          align="center"
          display="block"
          color="text.secondary"
          mt={3}
        >
          🔒 Your privacy is fully protected.
        </Typography>
        <Typography
          variant="caption"
          align="center"
          display="block"
          color="text.secondary"
        >
          👥 Real people. Real support. Just for you.
        </Typography>
      </Box>
    </Modal>
  );
};

export default OnboardingModal;
